var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.resources'] = (function () {
    'use strict';

    const selectedClass = 'resource--selected';
    const crossfadeImageClass = 'resources__img-crossfade-next';
    const crossfadeImageVisibleClass = 'resources__img-crossfade-next--visible';
    const imageTransitionFallbackMs = 300;
    const desktopBreakpoint = '(min-width: 992px)';

    const initialize = (widget) => {
        const resources = Array.from(widget.querySelectorAll('.resource'));
        const image = widget.querySelector('.resources__img img');
        const firstResource = resources[0] || null;
        const breakpointQuery = window.matchMedia(desktopBreakpoint);

        let isDesktopInteractive = breakpointQuery.matches;

        if (!resources.length) {
            return;
        }

        const initiallySelected = resources.find((resource) => resource.classList.contains(selectedClass)) || resources[0];
        setActiveResource(initiallySelected, resources, image, false);

        const setResourceTabIndices = (enableTabIndex) => {
            resources.forEach((resource) => {
                if (enableTabIndex) {
                    resource.setAttribute('tabindex', '0');
                    return;
                }

                resource.removeAttribute('tabindex');
            });
        };

        const applyBreakpointState = (interactiveEnabled) => {
            isDesktopInteractive = interactiveEnabled;
            setResourceTabIndices(interactiveEnabled);

            if (!interactiveEnabled && firstResource) {
                setActiveResource(firstResource, resources, image, false);
            }
        };

        applyBreakpointState(isDesktopInteractive);

        resources.forEach((resource) => {
            resource.addEventListener('focusin', () => {
                if (!isDesktopInteractive) {
                    return;
                }

                setActiveResource(resource, resources, image);
            });

            resource.addEventListener('mouseenter', () => {
                if (!isDesktopInteractive) {
                    return;
                }

                setActiveResource(resource, resources, image);
            });
        });

        const handleBreakpointChange = () => {
            applyBreakpointState(breakpointQuery.matches);
        };

        if (typeof breakpointQuery.addEventListener === 'function') {
            breakpointQuery.addEventListener('change', handleBreakpointChange);
        } else if (typeof breakpointQuery.addListener === 'function') {
            breakpointQuery.addListener(handleBreakpointChange);
        }
    };

    const updateImageWithFade = (image, nextSrc, animate = true) => {
        if (!image || !nextSrc) {
            return;
        }

        const currentSrc = image.getAttribute('src');
        if (currentSrc === nextSrc) {
            return;
        }

        if (!animate) {
            image.setAttribute('src', nextSrc);
            return;
        }

        const wrapper = image.parentElement;
        if (!wrapper) {
            image.setAttribute('src', nextSrc);
            return;
        }

        wrapper.querySelectorAll(`.${crossfadeImageClass}`).forEach((crossfadeImage) => crossfadeImage.remove());

        const token = `${Date.now()}-${Math.random()}`;
        image.dataset.crossfadeToken = token;

        const incomingImage = image.cloneNode(false);
        incomingImage.classList.add(crossfadeImageClass);
        incomingImage.setAttribute('src', nextSrc);
        incomingImage.setAttribute('aria-hidden', 'true');
        incomingImage.setAttribute('alt', image.getAttribute('alt') || '');

        const finalize = () => {
            if (image.dataset.crossfadeToken !== token) {
                incomingImage.remove();
                return;
            }

            image.setAttribute('src', nextSrc);
            incomingImage.remove();
            delete image.dataset.crossfadeToken;
        };

        incomingImage.addEventListener('transitionend', finalize, { once: true });
        wrapper.appendChild(incomingImage);

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                incomingImage.classList.add(crossfadeImageVisibleClass);
            });
        });

        window.setTimeout(() => {
            if (wrapper.contains(incomingImage)) {
                finalize();
            }
        }, imageTransitionFallbackMs);
    };

    const setActiveResource = (selectedResource, resources, image, animateImage = true) => {
        if (!selectedResource || !resources?.length) {
            return;
        }

        const selectedResources = resources.filter((resource) => resource.classList.contains(selectedClass));
        if (selectedResources.length === 1 && selectedResources[0] === selectedResource) {
            return;
        }

        resources.forEach((resource) => {
            resource.classList.toggle(selectedClass, resource === selectedResource);
        });

        updateImageWithFade(image, selectedResource.dataset.image, animateImage);
    };

    return {
        initialize
    };

})();